const CLIENT_TRANSLATIONS_FOLDER = '/translations/'

export const CLIENT_TRANSLATIONS_FILE_PATH = `${CLIENT_TRANSLATIONS_FOLDER}client-translations.json`

export const CLIENT_LINKS_FILE_PATH = `${CLIENT_TRANSLATIONS_FOLDER}client-links.json`

export const CLIENT_CONFIG_TRANSLATIONS_FILE_PATH = `${CLIENT_TRANSLATIONS_FOLDER}client-config-translations.json`

export const CLIENT_NEWS_FILE_PATH = `${CLIENT_TRANSLATIONS_FOLDER}client-news.json`

export const CLIENT_CONFIG_FILE_PATH = '/config/config.json'

export const CLIENT_THEME_FILE_PATH = '/theme/theme.json'
